<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getApplyList"
      ref="teacherList"
      @click:row="getDetails($event.item)"
      clickable
      hide-title-search>
      <template slot="title">
        <span class="pl-2 pr-4">二级单位审核</span>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn icon :disabled="item.firstAuditStatus+''!=='0'" @click="review(item)">
            <v-icon>{{$vuetify.icons.edit}}</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '通过';
      case '2':return '已拒绝';
      case '0':return '待审核';
      case '-1':return 'N/A';
      default:return v;
    }
  }
  export default {
    name: "firstReviewList_wx",
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'教工姓名',value:'name',sortable:false,align:'left'},
          {text:'教工编号',value:'loginId',sortable:false,align:'left'},
          {text:'教工单位',value:'orgName',sortable:false,align:'left',placeholder:'N/A'},
          {text:'计划进校时间',value:'stTime',sortable:true,align:"left"},
          {text:'计划进校事由',value:'reqComment',sortable:true,align:"left",maxWidth: '6em', tooltip: true},
          {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'业务部门审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'',value:'',sortable:false,align:'left'}
        ],
        selected:[],
        loading:false
      }
    },
    computed:{
      curOrg(){
        return this.$store.state.login.currentOrg
      }
    },
    methods:{
      async getApplyList({pagination}){
        let filter = [{
          key:'firstAuditStatus',
          value:'0'
        },
          {key:'auditType',value:'0'}
        ]
        let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,search:{key:'orgId',value:this.curOrg.id},filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
          }
        }
        return {items:items,amount:amount}
      },
      review(item){
        this.$router.push({name:'tempReviewDetail_wx',
          query:{
            id:item.id,
            type:'1'
          }
        })
      },
      getDetails(item){
        if(item.firstAuditStatus==='0'){
          this.$router.push({name:'tempReviewDetail_wx',query:{id:item.id,status:'review',type:'1'}})
        }else{
          this.$router.push({name:'tempReviewDetail_wx',query:{id:item.id,status:'readonly'}})
        }
      }
    }
  }
</script>

<style scoped>

</style>
